import {  Component, Input } from '@angular/core';
import { ChamelionOffer } from '@app/models/offerpack/ChamelionOffer';

@Component({
    selector: 'clever-chamaeleon-mini-detail',
    templateUrl: './chamaeleon-mini-detail.component.html',
    styleUrls: ['./chamaeleon-mini-detail.component.scss'],
    standalone: false
})
export class ChamaeleonMiniDetailComponent {
    @Input() datas: ChamelionOffer;
    constructor() { }
}
